var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EmptyState",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7656 78.0703C45.6694 78.7515 45.6197 79.4477 45.6197 80.1555C45.6197 88.3162 52.2352 94.9318 60.396 94.9318C68.5567 94.9318 75.1723 88.3162 75.1723 80.1555C75.1723 79.4477 75.1226 78.7515 75.0264 78.0703H110.882V110.94C110.882 112.98 109.228 114.634 107.188 114.634H13.6042C11.5641 114.634 9.91016 112.98 9.91016 110.94V78.0703H45.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4037 77.6937C76.4037 86.5345 69.2368 93.7014 60.396 93.7014C51.5552 93.7014 44.3883 86.5345 44.3883 77.6937C44.3883 77.4073 44.3958 77.1226 44.4107 76.8399H9.91016L21.6825 42.0321C22.19 40.5315 23.5978 39.5215 25.1819 39.5215H95.6101C97.1942 39.5215 98.602 40.5315 99.1095 42.0321L110.882 76.8399H76.3813C76.3962 77.1226 76.4037 77.4073 76.4037 77.6937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0609 78.8669C74.0609 85.6985 67.9428 92.4679 60.3958 92.4679C52.8487 92.4679 46.7307 85.6985 46.7307 78.8669C46.7307 78.6456 46.7371 77.1943 46.7498 76.9758H20.9922L31.0418 52.5415C31.475 51.382 32.6768 50.6016 34.029 50.6016H86.7625C88.1148 50.6016 89.3165 51.382 89.7498 52.5415L99.7994 76.9758H74.0418C74.0545 77.1943 74.0609 78.6456 74.0609 78.8669Z",
    fill: "#F6EFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4492 77.0911V109.707C11.4492 110.897 12.414 111.862 13.6041 111.862H107.188C108.378 111.862 109.342 110.897 109.342 109.707V77.0911L97.6513 42.5231C97.3552 41.6477 96.534 41.0586 95.61 41.0586H25.1817C24.2577 41.0586 23.4365 41.6477 23.1404 42.5231L11.4492 77.0911Z",
    stroke: "#A461D8",
    strokeWidth: 3.0784
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M27.1483 76.4609C31.9957 76.4609 37.2269 76.4609 42.8419 76.4609C45.1523 76.4609 45.1523 78.0846 45.1523 78.9237C45.1523 87.0844 51.9201 93.7 60.2686 93.7C68.6171 93.7 75.3849 87.0844 75.3849 78.9237C75.3849 78.0846 75.3849 76.4609 77.6953 76.4609H108.418M18.0039 76.4609H20.9915H18.0039Z",
    stroke: "#A461D8",
    strokeWidth: 3.0784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lines",
    d: "M91.3019 11.5717L77.6343 26.906M59.2865 6.27344V26.906V6.27344ZM27.1484 11.5717L40.8161 26.906L27.1484 11.5717Z",
    stroke: "#A461D8",
    strokeWidth: 3.0784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/EmptyState.6ee419cbcefbc0b896ba16aa0741210d.svg";
export { ForwardRef as ReactComponent };